import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea.jsx';
import { assignmentService } from '../../services/assignmentService';

const AssignmentCreate = () => {
  const [form, setForm] = React.useState({ title: '', description: '', classId: '', subjectId: '', dueDate: '' });
  const [saving, setSaving] = React.useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async () => {
    try {
      setSaving(true);
      await assignmentService.createAssignment(form);
      window.history.back();
    } catch (e) {
      alert(e.response?.data?.message || 'Failed to create assignment');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Create Assignment</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Input placeholder="Title" value={form.title} onChange={update('title')} />
          <Textarea placeholder="Description" value={form.description} onChange={update('description')} />
          <Input placeholder="Class ID" value={form.classId} onChange={update('classId')} />
          <Input placeholder="Subject ID" value={form.subjectId} onChange={update('subjectId')} />
          <Input placeholder="Due Date (YYYY-MM-DD)" value={form.dueDate} onChange={update('dueDate')} />
          <Button onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Create'}</Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AssignmentCreate;


